import React, { FC } from 'react';
import ProgressBar from 'common/components/base/progress-bar';

import './CustomProgressBar.scss';

type CustomProgressBarProps = {
    isIndeterminate?: boolean;
    labelComponent?: string;
};

const CustomProgressBar: FC<CustomProgressBarProps> = ({
    isIndeterminate,
    labelComponent
}: CustomProgressBarProps) => (
    <div className="loader-container">
        <ProgressBar isIndeterminate={isIndeterminate} labelComponent={labelComponent} />
    </div>
);

export default CustomProgressBar;
